import { BusinessWiseDiscountPriceEditDiaglogComponent } from './../business-wise-discount-price-edit-diaglog/business-wise-discount-price-edit-diaglog.component';
import { HttpService } from 'src/app/http.service';
import { Component } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-discount-product-price-edit',
  templateUrl: './discount-product-price-edit.component.html',
  styleUrls: ['./discount-product-price-edit.component.scss']
})
export class DiscountProductPriceEditComponent {
  discount_products = [];
  discount_business = [];
  ordered_product_ids = [];
  discount_price = {};

  constructor(private http: HttpService, public dialog: MatDialog) {
    this.getDiscountProducts();
    this.getDiscountBusiness();
    this.getBusinessWiseDiscountPriceDict();
  }

  getDiscountProducts() {
    this.http.getDiscountProducts().subscribe((data) => {
      console.log(data);
      this.discount_products = data['products'];
      this.ordered_product_ids = data['product_ids'];
    }, (error) => {
      console.log(error);
    });
  }

  getDiscountBusiness() {
    this.http.getDiscountBusiness().subscribe((data: []) => {
      console.log(data);
      this.discount_business = data;
    }, (error) => {
      console.log(error);
    });
  }

  getBusinessWiseDiscountPriceDict() {
    this.http.getBusinessWiseDiscountPriceDict().subscribe((data) => {
      console.log(data);
      this.discount_price = data;
    }, (error) => {
      console.log(error);
    });
  }

  openDialog(business_id: number, business_name: string, product_id: number, product_name: string, discount_price: number): void {
    console.log('dialog open');

    const dialogRef = this.dialog.open(BusinessWiseDiscountPriceEditDiaglogComponent, {
      height: '400px',
      width: '600px',
      data: {
        'business_id': business_id,
        'business_name': business_name,
        'product_id': product_id,
        'product_name': product_name,
        'discount_price': discount_price
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if ((res !== null) && (res !== undefined)) {
        this.updateDiscountPrice(res);
        this.getBusinessWiseDiscountPriceDict();
      }
    });
  }

  discountPrice(business_type_id, product_id) {
    if (this.discount_price.hasOwnProperty(business_type_id)) {
      if (this.discount_price[business_type_id].hasOwnProperty(product_id)) {
        return this.discount_price[business_type_id][product_id];
      } else {
        return 'N/A';
      }
    } else {
      return 'N/A';
    }
  }

  updateDiscountPrice(result) {
    console.log('update commission');
    if (this.discount_price.hasOwnProperty(result['business_id']) === false) {
      console.log('with in if');
      this.discount_price[result['business_id']] = {};
      this.discount_price[result['business_id']][result['product_id']] = result['discount_price'];
    } else {
      this.discount_price[result['business_id']][result['product_id']] = result['discount_price'];
    }
  }
}
